import classNames from "classnames";
import { useTranslate } from "../../../language/i18n";
import styles from "./CustomizedBadge.module.scss";

interface CustomizedBadgeProps {
  customCssClass?: string;
}

const CustomizedBadge = ({ customCssClass }: CustomizedBadgeProps) => {
  const translate = useTranslate();

  return <span className={classNames(styles.badge, customCssClass)}>{translate("CUSTOMIZED")}</span>;
};

export default CustomizedBadge;
